<template>
    <div class="row d-flex align-items-end wrapper mt-5 pb-3">
        <div class="col-12 col-sm-3 d-none d-sm-block">
            <img :src="kotoriImg" class="img-fluid rounded"/>
        </div>
        <div class="col-12 col-sm-9">
            <div class="row justify-content-center align-items-start">
                <img :src="kotoriImg" class="kotori img-fluid rounded col-3 d-block d-sm-none d-md-none d-lg-none"/>
                <h2 class="mt-5 mb-4 mb-sm-3 mt-sm-3 mb-lg-4 text-kotori col col-sm-12 text-center">Shorten your URL</h2>
            </div>
            <div class="row justify-content-center form-pc">
                <input ref="urlInput" @click="urlInputOnClick" class="col-12 col-sm-9 url-input form-control-lg mr-md-3"
                       type="text" placeholder="https://some.url" value=""/>
                <button class="col-12 col-sm-2 btn btn-kawaii text-white">pw</button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                kotoriImg: require('./kotori.png'),
                selectCooldown: false,
            }
        },
        methods: {
            urlInputOnClick() {
                if (!this.selectCooldown) {
                    this.$refs.urlInput.select();
                    this.selectCooldown = true;
                    setTimeout(() => {
                        this.selectCooldown = false;
                    }, 2000);
                }
            }
        }
    }
</script>

<style scoped>

    .kotori {
        min-width: 132px;
    }

    .wrapper {
        border-style: dotted;
        border-width: 0.3em;
        -webkit-border-radius: 1em;
        -moz-border-radius: 1em;
        border-radius: 1em;
        border-color: #ff7b98;

    }

    .btn-kawaii {
        background-color: #ff7b98;
    }

    .text-kotori {
        color: #786957;
        -webkit-transition: font-size 0.5s;
        -moz-transition: font-size 0.5s;
        -ms-transition: font-size 0.5s;
        -o-transition: font-size 0.5s;
        transition: font-size 0.5s;
    }

    @media screen and (min-width: 1200px) {
        .text-kotori {
            font-size: 5em;
        }
    }

    @media screen and (min-width: 992px) and (max-width: 1200px) {
        .text-kotori {
            font-size: 4em;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 992px) {
        .text-kotori {
            font-size: 3em;
        }
    }

    @media screen and (min-width: 576px) and (max-width: 768px) {
        .text-kotori {
            font-size: 2em;
        }
    }

    @media screen and (max-width: 576px) {
        .text-kotori {
            font-size: 1.5em;
        }
        .form-pc {
            margin: 1rem 0.1rem;
        }
        .form-pc button {
            margin-top: 0.2rem;
        }
        .pb-3 {
            padding-bottom: 0!important;
        }
    }

    .url-input {
        /*margin: 0.3em 0.2em 0 0;*/
    }
</style>


// WEBPACK FOOTER //
// 404.vue?715be6a1